<template lang="pug">
v-avatar(:size="size").k-user-avatar.box-shadow--avatar
  v-img(
    @error="handleError"
    :src="trueSrc"
    :lazy-src="lazySource"
    :width="size"
    :height="size"
    :alt="alt"
    ref="img"
  )
</template>

<script>
import { Sizeable } from '@/mixins'

export default {
  mixins: [
    Sizeable,
  ],
  props: {
    src: {
      type: [ String, Boolean ],
      default: false,
    },
    eager: {
      type: Boolean,
      default: false
    },
    alt: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      trueSrc: null,
      reloadAttempts: 0,
      reloadTimeout: null,
      lazySource: require('~images/user-grey.svg'),
    }
  },
  watch: {
    src: {
      handler () {
        this.trueSrc = this.src || this.lazySource
      },
      immediate: true
    }
  },
  destroyed () {
    if (this.reloadTimeout) {
      clearTimeout(this.reloadTimeout)
    }
  },
  methods: {
    handleError () {
      this.trueSrc = this.lazySource
      // if we've failed to load the image over 3 attempts (6 seconds)
      // then we give up, the image is most likely broken
      if (this.reloadAttempts >= 3) {
        return
      }
      this.reloadAttempts++
      // try again in in an exponential amount of time based on attempts
      this.reloadTimeout = setTimeout(
        () => {
          this.trueSrc = this.src
          this.$refs.img.loadImage()
        },
        this.reloadAttempts * 1000
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.k-user-avatar {
  ::v-deep {
    .v-responsive.v-image {
      height: 100% !important;
      width: 100% !important;
    }
    // remove lazy load blur
    .v-image__image--preload {
      filter: none !important;
      background-color: white;
    }
  }
}
</style>
